import React, { useState } from 'react';
import Header from '../shared/layout/header/Header';
import { Container } from 'react-bootstrap';
import LeftSideMenu from '../shared/layout/menu/LeftSideMenu';
import { Outlet, useLocation } from 'react-router-dom';
import { MessageBubble } from '../shared/components/message/MessageBubble';
import { useSelector } from 'react-redux';
import { IAllStates } from '../store/rootReducer';
import { CampaignHeader } from './brand/campaign/components/CampaignHeader';
import { UserRoles } from '../enum/UserRoles';
import { AgencyHeader } from './agency/components/AgencyHeader';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../enum/BootstrapBreakpoints';
import InfluencerHeader from '../shared/layout/header/InfluencerHeader';
import GlobalModals from '../shared/GlobalModals';
import { ClientHeader } from '../shared/components/global/ClientHeader';

export function Layout() {
    const { pathname } = useLocation();
    const {
        user: { userType, company },
    } = useSelector((state: IAllStates) => state.auth);
    const isGlobalDiscovery = company?.package?.globalDiscovery;
    const isGlobalBrandActive = useSelector((states: IAllStates) => states?.auth?.isGlobalBrand);
    const isSupplier = company?.isSupplier;
    const [isProfileSideBarOpen, setProfileSideBar] = useState(false);

    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.MD}px)`);
    const { BRAND, BRAND_MASTER, AGENCY, AGENCY_MASTER, INFLUENCER } = UserRoles;
    const isMessageScreen =
        pathname?.includes('brand/campaign/messages/') ||
        pathname?.includes('influencer/messages') ||
        pathname?.includes('agency/messages');

    const isCampaignOpen = pathname?.includes('brand/campaign');
    const containerRoutes = [
        '/influencer/offers',
        '/influencer/explore',
        '/settings',
        '/agency/explore',
        '/agency/offers',
    ];
    const isContainerFluid = containerRoutes.includes(pathname);
    const brandMobile = (userType === BRAND_MASTER || userType === BRAND) && isMobile;
    const agencyDisabledRoutes = ['/settings/edit', '/agency/influencer/profile'];
    const influencerDisabledRoutes = ['/influencer/profile/', '/settings/edit/'];
    const hideAgencyHeader = agencyDisabledRoutes.some(item => pathname.includes(item));
    const hideInfluencerHeader = influencerDisabledRoutes.some(item => pathname.includes(item));

    return (
        <>
            <Header isProfileSideBarOpen={isProfileSideBarOpen} setProfileSideBar={setProfileSideBar} />
            {isCampaignOpen && <CampaignHeader />}
            {[AGENCY, AGENCY_MASTER].includes(userType as UserRoles) && !hideAgencyHeader && <AgencyHeader />}
            {isGlobalBrandActive && isSupplier && <ClientHeader />}
            <Container fluid className="d-flex px-0">
                <LeftSideMenu />
                <Container
                    fluid={!isContainerFluid}
                    className={`px-3 pt-3 pb-5 mb-5 p-xl-4 mb-md-0 ${!isContainerFluid ? 'main-container' : ''}`}
                    onClick={() => setProfileSideBar(false)}
                >
                    {[INFLUENCER].includes(userType as UserRoles) && !hideInfluencerHeader && <InfluencerHeader />}
                    <Outlet />
                </Container>
            </Container>
            {!isGlobalDiscovery && (
                <div className={!isMessageScreen && !brandMobile ? '' : 'd-none'}>
                    <MessageBubble />
                </div>
            )}
            <GlobalModals />
        </>
    );
}
